var $ = jQuery;
$(function() {
    // Look for initially-open accordion objects
    $('.accordion').each(function() {
        if($(this).hasClass('active')) {
            var panel = $(this).next();
            panel.css('max-height', 'unset');
        }
    });

    // Accordion handling
    $('.accordion').click(function() {
        // Close others
        $('.accordion').not($(this)).removeClass('active').next().css('max-height', '0px');

        $(this).toggleClass('active');
        var panel = $(this).next();

        if ($(this).hasClass('active')){
            panel.css('max-height', panel.prop('scrollHeight') + "px");
        } else {
            panel.css('max-height', "0px");
        }
    });
});